import React from 'react';
import { Button, Typography } from 'mobily-ui-library/lib';
import BlueNetwork from '../../../assets/BlueNetwork.svg';
import NoNetwork from '../../../assets/NoNetwork.svg';
import './OntheGo.scss';

interface Props {
  rtl: boolean;
  results: Array<string>;
}

function OntheGo(props: Props) {
  const { rtl, results } = props;

  const handleClick = (value: any) => {
    window.open(value, '_blank');
  }

  const floatDirection = rtl ? 'ONTG-right' : 'ONTG-left';

  return (
    <div className={`ONTG__container ${floatDirection}`}>
      {results.map((result: any) => {
        const buttonLink = result.coverageList[0].additionalInfoList.filter((item: any) => item.key === "plans-link" || "more-link")[0];
        let noCoverage: boolean;
        return (
          <div className='ONTG__sections' key={result.subSectionId} style={{ float: rtl ? 'none' : 'left' }}>
            <Typography rtl={rtl} className='ONTG__options--title'>{rtl ? result.subSectionLabelAr : result.subSectionLabelEn}</Typography>

            <div className='ONTG__Network--Container'>
              {
                result.coverageList.map((list: any) => {
                  noCoverage = list.coveredLabelEn.toLowerCase().replace(/\s/g, '') === 'nocoverage';
                  const tag = list.additionalInfoList.filter((item: any) => item.key === "tag")[0];

                  return (
                    <React.Fragment key={list.coverageTypeLabelEn}>
                      <div className={list.coverageType !== '2G' ? 'ONTG__NetworkType' : 'twoG_Network'}>
                        {list.coverageType !== '2G' && (
                          <Typography rtl={rtl} className={'ONTG__Network'}>
                            <img src={noCoverage ? NoNetwork : BlueNetwork} alt='Network' />
                            <span>{rtl ? list.coverageTypeLabelAr : list.coverageTypeLabelEn}</span>
                          </Typography>
                        )}
                        <Typography rtl={rtl} className={noCoverage ? 'ONTG__CoverageType ONTG__NoCoverage' : (list.coverageType === 'NATIONAL_ROAMING' || list.coverageType === "5G" ? 'ONTG__CoverageType' : 'ONTG__CoverageType Other_coverageType')}>
                          {list.coverageType === "5G" ? (
                            rtl ? list.qualityLabelAr : list.qualityLabelEn
                          ) : (
                            list.coverageType === 'NATIONAL_ROAMING' ? (
                              rtl ? list.coveredLabelAr : list.coveredLabelEn
                            ) : null
                          )}
                        </Typography>

                        {!noCoverage && (tag && (
                          <Typography className='ONTG_Tag' rtl={rtl}>{rtl ? tag.label.ar : tag.label.en}</Typography>
                        ))}
                      </div>
                    </React.Fragment>
                  )
                })
              }
            </div>

            {result.coverageList.map((list: any) => {
              return (
                <React.Fragment key={list.coverageTypeLabelEn}>
                  {noCoverage && list.coverageType !== '2G' && (
                    <Typography className='ONTG__NoCoverage-Text' rtl={rtl}>
                      {rtl ? list.notCoveredMsgAr : list.notCoveredMsgEn}
                    </Typography>
                  )}
                </React.Fragment>
              )
            })}

            {result.subSectionLabelEn === 'Fastest option' ? (
              result.coverageList.map((list: any) => {
                return (
                  <React.Fragment key={list.coverageTypeLabelEn}>
                    {!noCoverage && (
                      <Button rtl={rtl} className='ONTG__buttonNames' onClick={() => handleClick(buttonLink.value)}>
                        {rtl ? buttonLink.label.ar : buttonLink.label.en}
                      </Button>
                    )}
                  </React.Fragment>
                )
              })
            ) : (
              <Typography rtl={rtl} className='ONTG__Buttonlabels' onClick={() => handleClick(buttonLink.value)}>{rtl ? buttonLink.label.ar : buttonLink.label.en}</Typography>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default OntheGo;